"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    avatarGroupPopoverClassNames: function() {
        return avatarGroupPopoverClassNames;
    },
    useAvatarGroupPopoverStyles_unstable: function() {
        return useAvatarGroupPopoverStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useAvatarGroupItemStylesstyles = require("../AvatarGroupItem/useAvatarGroupItemStyles.styles");
const _useAvatarStylesstyles = require("../Avatar/useAvatarStyles.styles");
const avatarGroupPopoverClassNames = {
    root: 'fui-AvatarGroupPopover',
    content: 'fui-AvatarGroupPopover__content',
    popoverSurface: 'fui-AvatarGroupPopover__popoverSurface',
    tooltip: 'fui-AvatarGroupPopover__tooltip',
    triggerButton: 'fui-AvatarGroupPopover__triggerButton'
};
/**
 * Styles for the content slot.
 */ const useContentStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        dclx09: "ftrb29c",
        B6of3ja: "f1hu3pq6",
        t21cq0: [
            "f11qmguv",
            "f1tyq0we"
        ],
        jrapky: "f19f4twv",
        Frg6f3: [
            "f1tyq0we",
            "f11qmguv"
        ],
        z8tnut: "f1g0x7ka",
        z189sj: [
            "fhxju0i",
            "f1cnd47f"
        ],
        Byoj8tv: "f1qch9an",
        uwmqm3: [
            "f1cnd47f",
            "fhxju0i"
        ],
        mc9l5x: "f22iagw",
        Beiy3e4: "f1vx9l62"
    }
}, {
    d: [
        ".ftrb29c{list-style-type:none;}",
        ".f1hu3pq6{margin-top:0;}",
        ".f11qmguv{margin-right:0;}",
        ".f1tyq0we{margin-left:0;}",
        ".f19f4twv{margin-bottom:0;}",
        ".f1g0x7ka{padding-top:0;}",
        ".fhxju0i{padding-right:0;}",
        ".f1cnd47f{padding-left:0;}",
        ".f1qch9an{padding-bottom:0;}",
        ".f22iagw{display:flex;}",
        ".f1vx9l62{flex-direction:column;}"
    ]
});
/**
 * Styles for the popoverSurface slot.
 */ const usePopoverSurfaceStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        Bxyxcbc: "fopcw2o",
        sshi5w: "f1n5o1gx",
        B68tc82: "f1p9o1ba",
        Bmxbyg5: "fqkkaap",
        z8tnut: "f1kwiid1",
        z189sj: [
            "f1vdfbxk",
            "f1f5gg8d"
        ],
        Byoj8tv: "f5b47ha",
        uwmqm3: [
            "f1f5gg8d",
            "f1vdfbxk"
        ],
        a9b677: "f13dwy2t"
    }
}, {
    d: [
        ".fopcw2o{max-height:220px;}",
        ".f1n5o1gx{min-height:80px;}",
        ".f1p9o1ba{overflow-x:hidden;}",
        ".fqkkaap{overflow-y:scroll;}",
        ".f1kwiid1{padding-top:var(--spacingVerticalS);}",
        ".f1vdfbxk{padding-right:var(--spacingHorizontalS);}",
        ".f1f5gg8d{padding-left:var(--spacingHorizontalS);}",
        ".f5b47ha{padding-bottom:var(--spacingVerticalS);}",
        ".f13dwy2t{width:220px;}"
    ]
});
/**
 * Styles for the triggerButton slot.
 */ const useTriggerButtonStyles = /*#__PURE__*/ (0, _react.__styles)({
    base: {
        mc9l5x: "ftuwxu6",
        qhf8xq: "f10pi13n",
        Bnnss6s: "fi64zpg",
        Brf1p80: "f4d9j23",
        Bt984gj: "f122n59",
        sj55zd: "f19n0e5",
        De3pzq: "fxugw4r",
        g2u3we: "fj3muxo",
        h3c5rm: [
            "f1akhkt",
            "f1lxtadh"
        ],
        B9xav0g: "f1aperda",
        zhjwy3: [
            "f1lxtadh",
            "f1akhkt"
        ],
        Bbmb7ep: [
            "f8fbkgy",
            "f1nfllo7"
        ],
        Beyfa6y: [
            "f1nfllo7",
            "f8fbkgy"
        ],
        B7oj6ja: [
            "f1djnp8u",
            "f1s8kh49"
        ],
        Btl43ni: [
            "f1s8kh49",
            "f1djnp8u"
        ],
        icvyot: "fzkkow9",
        vrafjx: [
            "fcdblym",
            "fjik90z"
        ],
        oivjwe: "fg706s2",
        wvpqe5: [
            "fjik90z",
            "fcdblym"
        ],
        z8tnut: "f1g0x7ka",
        z189sj: [
            "fhxju0i",
            "f1cnd47f"
        ],
        Byoj8tv: "f1qch9an",
        uwmqm3: [
            "f1cnd47f",
            "fhxju0i"
        ],
        Bjwas2f: "fw33nwi",
        Bn1d65q: [
            "f1ptkjjm",
            "fmzzjfk"
        ],
        Bxeuatn: "f15j0dln",
        n51gp8: [
            "fmzzjfk",
            "f1ptkjjm"
        ]
    },
    pie: {
        De3pzq: "f1c21dwh",
        g2u3we: "fghlq4f",
        h3c5rm: [
            "f1gn591s",
            "fjscplz"
        ],
        B9xav0g: "fb073pr",
        zhjwy3: [
            "fjscplz",
            "f1gn591s"
        ],
        sj55zd: "f44pa96"
    },
    focusIndicator: {
        Bbcte9g: "fhqs6ru",
        Bn40d3w: [
            "f14qhy8p",
            "f12lscv2"
        ],
        i2cumq: "f1p9w1qi",
        lbo84a: [
            "f12lscv2",
            "f14qhy8p"
        ],
        B5gfjzb: "ff4w5z6",
        u5e7qz: [
            "f1slf1ze",
            "f33ndkz"
        ],
        Bbjhlyh: "fsap1ud",
        mqozju: [
            "f33ndkz",
            "f1slf1ze"
        ],
        B8q5s1w: "f17t0x8g",
        Bci5o5g: [
            "f194v5ow",
            "fk7jm04"
        ],
        n8qw10: "f1qgg65p",
        Bdrgwmp: [
            "fk7jm04",
            "f194v5ow"
        ],
        g9k6zt: "f1nev41a"
    },
    states: {
        Bi91k9c: "feu1g3u",
        Jwef8y: "f1knas48",
        Bgoe8wy: "fvcxoqz",
        Bwzppfd: [
            "f1ub3y4t",
            "f1m52nbi"
        ],
        oetu4i: "f1xlaoq0",
        gg5e9n: [
            "f1m52nbi",
            "f1ub3y4t"
        ],
        lj723h: "f1g4hkjv",
        ecr2s2: "fb40n2d",
        B6oc9vd: "fvs00aa",
        ak43y8: [
            "f1assf6x",
            "f4ruux4"
        ],
        wmxk5l: "fumykes",
        B50zh58: [
            "f4ruux4",
            "f1assf6x"
        ]
    },
    selected: {
        sj55zd: "f14nttnl",
        De3pzq: "f1nfm20t",
        g2u3we: "f1ly1fcm",
        h3c5rm: [
            "fi8bssc",
            "fj6btzu"
        ],
        B9xav0g: "f1s9tnsa",
        zhjwy3: [
            "fj6btzu",
            "fi8bssc"
        ]
    },
    icon12: {
        Be2twd7: "f1ugzwwg"
    },
    icon16: {
        Be2twd7: "f4ybsrx"
    },
    icon20: {
        Be2twd7: "fe5j1ua"
    },
    icon24: {
        Be2twd7: "f1rt2boy"
    },
    icon28: {
        Be2twd7: "f24l1pt"
    },
    icon32: {
        Be2twd7: "ffl51b"
    },
    icon48: {
        Be2twd7: "f18m8u13"
    },
    caption2Strong: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f13mqy1h",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fcpl73t"
    },
    caption1Strong: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fwrc4pm"
    },
    body1Strong: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fkhj508",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f1i3iumi"
    },
    subtitle2: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fod5ikn",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "faaz57k"
    },
    subtitle1: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f1pp30po",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "f106mvju"
    },
    title3: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f1x0m3f5",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fb86gi6"
    },
    borderThin: {
        B4j52fo: "f192inf7",
        Bekrc4i: [
            "f5tn483",
            "f1ojsxk5"
        ],
        Bn0qgzm: "f1vxd6vx",
        ibv6hh: [
            "f1ojsxk5",
            "f5tn483"
        ]
    },
    borderThick: {
        B4j52fo: "f18zi460",
        Bekrc4i: [
            "f1wpluaz",
            "fsfsuhs"
        ],
        Bn0qgzm: "fmklw6v",
        ibv6hh: [
            "fsfsuhs",
            "f1wpluaz"
        ]
    },
    borderThicker: {
        B4j52fo: "fgx37oo",
        Bekrc4i: [
            "f130t4y6",
            "f1efpmoh"
        ],
        Bn0qgzm: "fv51ejd",
        ibv6hh: [
            "f1efpmoh",
            "f130t4y6"
        ]
    },
    borderThickest: {
        B4j52fo: "fwn6jck",
        Bekrc4i: [
            "figl7jc",
            "f1g0iy8l"
        ],
        Bn0qgzm: "f1b8shu7",
        ibv6hh: [
            "f1g0iy8l",
            "figl7jc"
        ]
    }
}, {
    d: [
        ".ftuwxu6{display:inline-flex;}",
        ".f10pi13n{position:relative;}",
        ".fi64zpg{flex-shrink:0;}",
        ".f4d9j23{justify-content:center;}",
        ".f122n59{align-items:center;}",
        ".f19n0e5{color:var(--colorNeutralForeground1);}",
        ".fxugw4r{background-color:var(--colorNeutralBackground1);}",
        ".fj3muxo{border-top-color:var(--colorNeutralStroke1);}",
        ".f1akhkt{border-right-color:var(--colorNeutralStroke1);}",
        ".f1lxtadh{border-left-color:var(--colorNeutralStroke1);}",
        ".f1aperda{border-bottom-color:var(--colorNeutralStroke1);}",
        ".f8fbkgy{border-bottom-right-radius:var(--borderRadiusCircular);}",
        ".f1nfllo7{border-bottom-left-radius:var(--borderRadiusCircular);}",
        ".f1djnp8u{border-top-right-radius:var(--borderRadiusCircular);}",
        ".f1s8kh49{border-top-left-radius:var(--borderRadiusCircular);}",
        ".fzkkow9{border-top-style:solid;}",
        ".fcdblym{border-right-style:solid;}",
        ".fjik90z{border-left-style:solid;}",
        ".fg706s2{border-bottom-style:solid;}",
        ".f1g0x7ka{padding-top:0;}",
        ".fhxju0i{padding-right:0;}",
        ".f1cnd47f{padding-left:0;}",
        ".f1qch9an{padding-bottom:0;}",
        ".f1c21dwh{background-color:var(--colorTransparentBackground);}",
        ".fghlq4f{border-top-color:var(--colorTransparentStroke);}",
        ".f1gn591s{border-right-color:var(--colorTransparentStroke);}",
        ".fjscplz{border-left-color:var(--colorTransparentStroke);}",
        ".fb073pr{border-bottom-color:var(--colorTransparentStroke);}",
        ".f44pa96{color:transparent;}",
        ".fhqs6ru[data-fui-focus-visible]{border-top-width:var(--strokeWidthThick);}",
        ".f14qhy8p[data-fui-focus-visible]{border-right-width:var(--strokeWidthThick);}",
        ".f12lscv2[data-fui-focus-visible]{border-left-width:var(--strokeWidthThick);}",
        ".f1p9w1qi[data-fui-focus-visible]{border-bottom-width:var(--strokeWidthThick);}",
        ".ff4w5z6[data-fui-focus-visible]{border-top-style:solid;}",
        ".f1slf1ze[data-fui-focus-visible]{border-right-style:solid;}",
        ".f33ndkz[data-fui-focus-visible]{border-left-style:solid;}",
        ".fsap1ud[data-fui-focus-visible]{border-bottom-style:solid;}",
        ".f17t0x8g[data-fui-focus-visible]{border-top-color:var(--colorStrokeFocus2);}",
        ".f194v5ow[data-fui-focus-visible]{border-right-color:var(--colorStrokeFocus2);}",
        ".fk7jm04[data-fui-focus-visible]{border-left-color:var(--colorStrokeFocus2);}",
        ".f1qgg65p[data-fui-focus-visible]{border-bottom-color:var(--colorStrokeFocus2);}",
        ".f1nev41a[data-fui-focus-visible]{outline-style:none;}",
        ".f14nttnl{color:var(--colorNeutralForeground1Selected);}",
        ".f1nfm20t{background-color:var(--colorNeutralBackground1Selected);}",
        ".f1ly1fcm{border-top-color:var(--colorNeutralStroke1Selected);}",
        ".fi8bssc{border-right-color:var(--colorNeutralStroke1Selected);}",
        ".fj6btzu{border-left-color:var(--colorNeutralStroke1Selected);}",
        ".f1s9tnsa{border-bottom-color:var(--colorNeutralStroke1Selected);}",
        ".f1ugzwwg{font-size:12px;}",
        ".f4ybsrx{font-size:16px;}",
        ".fe5j1ua{font-size:20px;}",
        ".f1rt2boy{font-size:24px;}",
        ".f24l1pt{font-size:28px;}",
        ".ffl51b{font-size:32px;}",
        ".f18m8u13{font-size:48px;}",
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f13mqy1h{font-size:var(--fontSizeBase100);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fcpl73t{line-height:var(--lineHeightBase100);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}",
        ".fkhj508{font-size:var(--fontSizeBase300);}",
        ".f1i3iumi{line-height:var(--lineHeightBase300);}",
        ".fod5ikn{font-size:var(--fontSizeBase400);}",
        ".faaz57k{line-height:var(--lineHeightBase400);}",
        ".f1pp30po{font-size:var(--fontSizeBase500);}",
        ".f106mvju{line-height:var(--lineHeightBase500);}",
        ".f1x0m3f5{font-size:var(--fontSizeBase600);}",
        ".fb86gi6{line-height:var(--lineHeightBase600);}",
        ".f192inf7{border-top-width:var(--strokeWidthThin);}",
        ".f5tn483{border-right-width:var(--strokeWidthThin);}",
        ".f1ojsxk5{border-left-width:var(--strokeWidthThin);}",
        ".f1vxd6vx{border-bottom-width:var(--strokeWidthThin);}",
        ".f18zi460{border-top-width:var(--strokeWidthThick);}",
        ".f1wpluaz{border-right-width:var(--strokeWidthThick);}",
        ".fsfsuhs{border-left-width:var(--strokeWidthThick);}",
        ".fmklw6v{border-bottom-width:var(--strokeWidthThick);}",
        ".fgx37oo{border-top-width:var(--strokeWidthThicker);}",
        ".f130t4y6{border-right-width:var(--strokeWidthThicker);}",
        ".f1efpmoh{border-left-width:var(--strokeWidthThicker);}",
        ".fv51ejd{border-bottom-width:var(--strokeWidthThicker);}",
        ".fwn6jck{border-top-width:var(--strokeWidthThickest);}",
        ".figl7jc{border-right-width:var(--strokeWidthThickest);}",
        ".f1g0iy8l{border-left-width:var(--strokeWidthThickest);}",
        ".f1b8shu7{border-bottom-width:var(--strokeWidthThickest);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.fw33nwi{border-top-color:CanvasText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ptkjjm{border-right-color:CanvasText;}.fmzzjfk{border-left-color:CanvasText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f15j0dln{border-bottom-color:CanvasText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ],
    h: [
        ".feu1g3u:hover{color:var(--colorNeutralForeground1Hover);}",
        ".f1knas48:hover{background-color:var(--colorNeutralBackground1Hover);}",
        ".fvcxoqz:hover{border-top-color:var(--colorNeutralStroke1Hover);}",
        ".f1ub3y4t:hover{border-right-color:var(--colorNeutralStroke1Hover);}",
        ".f1m52nbi:hover{border-left-color:var(--colorNeutralStroke1Hover);}",
        ".f1xlaoq0:hover{border-bottom-color:var(--colorNeutralStroke1Hover);}"
    ],
    a: [
        ".f1g4hkjv:active{color:var(--colorNeutralForeground1Pressed);}",
        ".fb40n2d:active{background-color:var(--colorNeutralBackground1Pressed);}",
        ".fvs00aa:active{border-top-color:var(--colorNeutralStroke1Pressed);}",
        ".f1assf6x:active{border-right-color:var(--colorNeutralStroke1Pressed);}",
        ".f4ruux4:active{border-left-color:var(--colorNeutralStroke1Pressed);}",
        ".fumykes:active{border-bottom-color:var(--colorNeutralStroke1Pressed);}"
    ]
});
const useAvatarGroupPopoverStyles_unstable = (state)=>{
    const { indicator, size, layout, popoverOpen } = state;
    const sizeStyles = (0, _useAvatarStylesstyles.useSizeStyles)();
    const triggerButtonStyles = useTriggerButtonStyles();
    const contentStyles = useContentStyles();
    const popoverSurfaceStyles = usePopoverSurfaceStyles();
    const groupChildClassName = (0, _useAvatarGroupItemStylesstyles.useGroupChildClassName)(layout, size);
    const triggerButtonClasses = [];
    if (size < 36) {
        triggerButtonClasses.push(triggerButtonStyles.borderThin);
    } else if (size < 56) {
        triggerButtonClasses.push(triggerButtonStyles.borderThick);
    } else if (size < 72) {
        triggerButtonClasses.push(triggerButtonStyles.borderThicker);
    } else {
        triggerButtonClasses.push(triggerButtonStyles.borderThickest);
    }
    if (indicator === 'count') {
        if (size <= 24) {
            triggerButtonClasses.push(triggerButtonStyles.caption2Strong);
        } else if (size <= 28) {
            triggerButtonClasses.push(triggerButtonStyles.caption1Strong);
        } else if (size <= 40) {
            triggerButtonClasses.push(triggerButtonStyles.body1Strong);
        } else if (size <= 56) {
            triggerButtonClasses.push(triggerButtonStyles.subtitle2);
        } else if (size <= 96) {
            triggerButtonClasses.push(triggerButtonStyles.subtitle1);
        } else {
            triggerButtonClasses.push(triggerButtonStyles.title3);
        }
    } else {
        if (size <= 16) {
            triggerButtonClasses.push(triggerButtonStyles.icon12);
        } else if (size <= 24) {
            triggerButtonClasses.push(triggerButtonStyles.icon16);
        } else if (size <= 40) {
            triggerButtonClasses.push(triggerButtonStyles.icon20);
        } else if (size <= 48) {
            triggerButtonClasses.push(triggerButtonStyles.icon24);
        } else if (size <= 56) {
            triggerButtonClasses.push(triggerButtonStyles.icon28);
        } else if (size <= 72) {
            triggerButtonClasses.push(triggerButtonStyles.icon32);
        } else {
            triggerButtonClasses.push(triggerButtonStyles.icon48);
        }
    }
    state.triggerButton.className = (0, _react.mergeClasses)(avatarGroupPopoverClassNames.triggerButton, groupChildClassName, sizeStyles[size], triggerButtonStyles.base, layout === 'pie' && triggerButtonStyles.pie, triggerButtonStyles.focusIndicator, layout !== 'pie' && triggerButtonStyles.states, layout !== 'pie' && popoverOpen && triggerButtonStyles.selected, ...triggerButtonClasses, state.triggerButton.className);
    state.content.className = (0, _react.mergeClasses)(avatarGroupPopoverClassNames.content, contentStyles.base, state.content.className);
    state.popoverSurface.className = (0, _react.mergeClasses)(avatarGroupPopoverClassNames.popoverSurface, popoverSurfaceStyles.base, state.popoverSurface.className);
    return state;
}; //# sourceMappingURL=useAvatarGroupPopoverStyles.styles.js.map
